import React from 'react'
import { MileageTracking as MileageTrackingView } from '@layerfi/components'

import { AccountingLayout } from '../../../layouts/AccountingLayout'

export const MileageTracking = () => {
  return (
    <AccountingLayout>
      <MileageTrackingView />
    </AccountingLayout>
  )
}
